import { AppSidebar } from "@/components/app-sidebar";
import { MobileMenuButton } from "@/components/mobile-menu-button";
import { SidebarInset, SidebarProvider } from "@/components/ui/sidebar";
import { Toaster } from "@/components/ui/sonner";
import { NovuProvider } from "@novu/react";
import {
  CatchBoundary,
  createRootRoute,
  Outlet,
  redirect,
} from "@tanstack/react-router";
import { useCurrentUser } from "../data/auth/hooks";

export const Route = createRootRoute({
  beforeLoad: ({ location }) => {
    const hasToken = !!localStorage.getItem("auth_token");

    // Allow access to auth-related routes without authentication
    const authRoutes = [
      "/login",
      "/register",
      "/forgot-password",
      "/reset-password",
    ];

    if (!hasToken && !authRoutes.includes(location.pathname)) {
      throw redirect({
        to: "/login",
      });
    }

    if (hasToken && authRoutes.includes(location.pathname)) {
      throw redirect({
        to: "/home",
      });
    }
  },
  component: () => {
    const hasToken = !!localStorage.getItem("auth_token");

    // If not authenticated, render without the sidebar
    if (!hasToken) {
      return <Outlet />;
    }

    const { data: user } = useCurrentUser();

    if (!user) {
      return null;
    }

    // If authenticated, render with the sidebar
    return (
      <CatchBoundary
        getResetKey={() => "reset"}
        onCatch={(error) => console.error(error)}
      >
        <NovuProvider
          applicationIdentifier={
            process.env.NODE_ENV === "development"
              ? "bt9yrvaEDBk9"
              : "TvtmTMqKVoUD"
          }
          subscriberHash={user.novuSubHashedId}
          subscriber={{
            subscriberId: user.id,
            firstName: user.firstName,
            lastName: user.lastName,
            email: user.email,
          }}
        >
          <SidebarProvider>
            <AppSidebar />

            <SidebarInset>
              <Outlet />
            </SidebarInset>

            <MobileMenuButton />

            <Toaster
              duration={3000}
              position="bottom-right"
              closeButton={true}
              theme="light"
              visibleToasts={3}
              className="!z-40"
            />
          </SidebarProvider>
        </NovuProvider>

        {/* <TanStackRouterDevtools position="bottom-right" /> */}
      </CatchBoundary>
    );
  },
});
